module.exports = __webpack_public_path__ + "static/media/ergonomic-1.83dd005d.jpg";